// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__y-t8Y","filesListContainer":"PosDisputesFiles_filesListContainer__3nIwr","filesButton":"PosDisputesFiles_filesButton__1gDGA"};